<template>
<!--  :route-to="routeTo"-->
  <gj-link
      @click="routeClick">
    <slot></slot>
  </gj-link>
</template>

<script>
  import {adStore} from "../../../common/store";
  import {convertToDate} from "@/utils/date.util";

  export default {
    name: "app-sp-ad-route-link",
    props: {
      adManager: {
        type: Object,
        default: null
      },
      adCampaignManager: {
        type: Object,
        default: null
      },
      adGroupManager: {
        type: Object,
        default: null
      },
    },
    computed: {
      routeTo() {
        if (this.adManager) {
          return {};
        } else if (this.adCampaignManager) {
          const marketId = this.adCampaignManager.marketId;
          const campaign = this.adCampaignManager.campaign;
          return {
            path: `/ad/sp-ad/ad-campaign-manager/${campaign.campaignId}`,
            query: {marketId}
          }
        } else if (this.adGroupManager) {
          const marketId = this.adGroupManager.marketId;
          const campaign = this.adGroupManager.campaign;
          const group = this.adGroupManager.group;
          return {
            path: `/ad/sp-ad/ad-group-manager/${campaign.campaignId}/${group.groupId}`,
            query: {marketId}
          }
        } else {
          return {};
        }
      }
    },
    methods: {
      routeClick() {
        if (this.adManager) {
          adStore.SP.campaign = null;
          adStore.SP.group = null;
        } else if (this.adCampaignManager) {
          adStore.SP.campaign = this.adCampaignManager.campaign;
          adStore.SP.campaignDate = this.adCampaignManager.date;
          adStore.SP.group = null;
        } else if (this.adGroupManager) {
          adStore.SP.group = this.adGroupManager.group;
          adStore.SP.campaign = this.adGroupManager.campaign;
          adStore.SP.campaignDate = this.adGroupManager.date;
          adStore.SP.groupDate = this.adGroupManager.date;
        }
      },
    }
  }
</script>

<style scoped>

</style>
